/**
 * 汎用の事業部モジュール(暫定)。
 *
 * 各事業部が自前の計算ロジックを持つまでの間、共通サマリー5行を返すために使う。
 * 集計は「実績の取引(plEntryOf() で actual)を accounts.pl_line で5行に畳む」だけ。
 *
 * 事業部セッションが `/modules/<事業部名>/` に自前の実装を作ったら、
 * moduleRegistry の対応を差し替える。**全社PL側のコードは変更不要。**
 */
import {
  fetchBudgets,
  fetchBookedTransactions,
  fetchPendingTransactions,
  summarizeBudgets,
  summarizeTransactions,
} from './plRepo';
import type {
  Account,
  DepartmentId,
  DepartmentModule,
  DepartmentSummary,
  MonthStr,
  SummaryLine,
} from '@core/lib/types';

export function createGenericDepartmentModule(
  departmentId: DepartmentId,
  accounts: Account[],
): DepartmentModule {
  return {
    departmentId,
    async getMonthlySummary(month: MonthStr): Promise<DepartmentSummary> {
      const [booked, budgets] = await Promise.all([
        fetchBookedTransactions(departmentId, month),
        fetchBudgets(departmentId, month),
      ]);
      return {
        budget: summarizeBudgets(budgets, accounts),
        actual: summarizeTransactions(booked, accounts),
      };
    },
  };
}

/**
 * 見込み(承認前+計上日の月がまだ来ていない承認済み以降。plEntryOf() で forecast)。**実績には含めない。**
 * 全社PLでは実績とは別の列で示す(decisions.md 2026-08-20)。
 */
export async function getPendingSummary(
  departmentId: DepartmentId,
  month: MonthStr,
  accounts: Account[],
): Promise<SummaryLine> {
  const pending = await fetchPendingTransactions(departmentId, month);
  return summarizeTransactions(pending, accounts);
}
